import { ComponentType } from 'react';
import { reduxForm, ConfigProps, FormErrors, InjectedFormProps, DecoratedFormProps } from 'redux-form';
import ReduxFormUtils from 'qc-redux-form_utils';
import { Dispatch } from 'redux';
import FormUtils from 'qc-dom_utils';

const { flattenErrors } = ReduxFormUtils;
const { focusFirstInvalid } = FormUtils.form;

const reduxFormWrapper: typeof reduxForm =
    <FormData, P, ErrorType>(
        config: ConfigProps<FormData, P, ErrorType> | Partial<ConfigProps<FormData, P, ErrorType>>,
    ) =>
    (FormComponent: ComponentType<P & InjectedFormProps<FormData, P, ErrorType>>) =>
        reduxForm({
            ...config,
            onSubmitFail: (
                errors: FormErrors<FormData, ErrorType> | undefined,
                dispatch: Dispatch<any>,
                submitError: any,
                props: P & DecoratedFormProps<FormData, P, ErrorType>,
            ): void => {
                const { form } = props;

                const { onSubmitFail } = config;

                focusFirstInvalid(form, flattenErrors(errors));

                if (onSubmitFail) {
                    onSubmitFail(errors, dispatch, submitError, props);
                }
            },
        })(FormComponent);

export { reduxFormWrapper };
